import React, { createContext, PropsWithChildren, useContext } from "react"
import { useHistory, useLocation, useParams } from "react-router-dom"

import { AuthResponse } from "./LoginService"
import { StartPagePath } from "../route/paths"
import { toApp } from "@cirrus/app-common/login/redirect/toApp"
import { toAfterExternalLogin } from "@cirrus/app-common/login/redirect/toAfterExternalLogin"

export class NavigationService {
  search: Record<string, string> = {}
  useParams: () => any = () => undefined
  navigate: (path: StartPagePath | -1) => any = (path) => console.debug("Navigate: ", path)
  redirectToApp: (authResult: AuthResponse) => any = (authResult) => console.debug(authResult)
  redirectToAfterExternalLogin: (authResult: AuthResponse) => any = (authResult) => console.debug(authResult)
}

const NavigationServiceContext = createContext(new NavigationService())

export const useNavigationService = () => useContext(NavigationServiceContext)

export const NavigationServiceProvider = (props: NavigationServiceProps) => {

  const { children, service } = props

  return (<NavigationServiceContext.Provider value={service}>
    {children}
  </NavigationServiceContext.Provider>)
}

export const WithAppNavigationService = ({ children }: PropsWithChildren) => {
  const history = useHistory()
  const { search } = useLocation()

  const service_ = {
    search: Object.fromEntries(new URLSearchParams(search)),
    useParams, // Pass hook instead of its returned data because the params are invisible outside their Route components
    redirectToApp: toApp,
    redirectToAfterExternalLogin: toAfterExternalLogin,
    // redirectToAfterExternalLogin: (authResult) =>  console.debug(authResult),
    navigate: (path) => path === -1 ? history.goBack() : history.push(path)
  }

  // const service_ = new NavigationService()

  return (
    <NavigationServiceProvider service={service_}>
      {children}
    </NavigationServiceProvider>)
}

type NavigationServiceProps = PropsWithChildren & {
  service: NavigationService
}